import { NavItem } from '@billy/design-system'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { DocumentStaticActionType } from '../enums/documentStaticActionType'

export const useDocumentActionItems = (values: DocumentStaticActionType[]): NavItem<DocumentStaticActionType>[] => {
  const { t } = useTranslation()

  return useMemo(() => {
    const getDocumentActionItem = (value: DocumentStaticActionType): NavItem<DocumentStaticActionType> => {
      switch (value) {
        case DocumentStaticActionType.Rename:
          return {
            children: t('documents.actions.rename'),
            iconLeft: 'squarePen',
            id: 'rename',
            value,
            variant: 'primary',
          }
        case DocumentStaticActionType.Move:
          return {
            children: t('documents.actions.move'),
            iconLeft: 'folderInput',
            id: 'move',
            value,
            variant: 'primary',
          }
        case DocumentStaticActionType.Download:
          return {
            children: t('documents.actions.download'),
            iconLeft: 'download',
            id: 'download',
            value,
            variant: 'primary',
          }
        case DocumentStaticActionType.CopyLink:
          return {
            children: t('documents.actions.copy_link'),
            iconLeft: 'link',
            id: 'copy-link',
            value,
            variant: 'primary',
          }
        case DocumentStaticActionType.Delete:
          return {
            children: t('documents.actions.delete'),
            iconLeft: 'trash',
            id: 'delete',
            value,
            variant: 'danger',
          }
      }
    }

    return values.map((value) => getDocumentActionItem(value))
  }, [t, values])
}
